import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { OddConstant } from '~/constant/odd.constant';
import { translationHelper } from '~/helpers/translation.helper';
import { uiHelper } from '~/helpers/ui.helper';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';

declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'oddTypeSelector',
    templateUrl: './oddTypeSelector.html',
})
export class OddTypeSelector implements OnInit, OnChanges {
    @Input() public _data;
    _sendData;
    @Input() public selectedItem;
    @Input() public isPaddingLeft = false;
    @Input() public onlyHeaderFor;
    @Input() public rowNumber = 1;
    @Input() public oddNumber = 2;
    public _typeOfList = 'pre';

    public _ODD_TYPE = this._OddConstant.ODD_TYPE;
    public _ODD_TEXT_ITEMS = Array(this.oddNumber);

    public init: boolean;

    constructor(
        public tournamentsService: TournamentsService,
        private _OddConstant: OddConstant,
        private _uiHelper: uiHelper,
        private _translationHelper: translationHelper,
    ) {}

    public ngOnInit() {
        this._sendData = this._data.map(item => {
            return {
                ...this._OddConstant.ODD_TYPE_DROPDOWN[item],
                name: this._translationHelper.transformTranslate(this._OddConstant.ODD_TYPE_DROPDOWN[item].name),
            };
        });
        if (!this.selectedItem) {
            this.selectedItem = this._sendData[0];
        }

        this._typeOfList = this._uiHelper.typeOfList;
        this._uiHelper.typeOfListListener.subscribe(x => {
            this._typeOfList = x;
        });

        // initiaL SET
        this.oddTypeSelectHandler(this.selectedItem.key);
        this.oddText();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        // console.log('im----------', this._data);

        this._sendData = this._data.map(item => {
            return {
                ...this._OddConstant.ODD_TYPE_DROPDOWN[item],
                name: this._translationHelper.transformTranslate(this._OddConstant.ODD_TYPE_DROPDOWN[item].name),
            };
        });
        this.selectedItem = this._sendData[0];

        this.oddText();
    }

    public oddText() {
        // console.log(this.selectedItem);

        this._ODD_TEXT_ITEMS = this._ODD_TYPE[this.selectedItem.odd_type];
        if (!this._ODD_TEXT_ITEMS) return;
        if (this._ODD_TEXT_ITEMS.length < this.oddNumber) {
            const count = this.oddNumber - this._ODD_TEXT_ITEMS.length;
            for (let i = 0; i < count; i++) {
                this._ODD_TEXT_ITEMS.push('');
            }
        }
    }

    public oddTypeSelectHandler(e) {
        // console.log('oddtypeSelect-------', e);
        if (e) {
            this.selectedItem = this._sendData.filter(x => x.key === e)[0];

            if (this.onlyHeaderFor === 'pre') {
                this._uiHelper.setOddType_PRE(e, this.rowNumber);
            } else if (this.onlyHeaderFor === 'live') {
                this._uiHelper.setOddType_LIVE(e, this.rowNumber);
            } else {
                this._uiHelper.setOddType_PRE(e, this.rowNumber);
                this._uiHelper.setOddType_LIVE(e, this.rowNumber);
            }
            this.oddText();
        }
    }
}
